import LazyImage from "@/my_components/Common/LazyImage";
import Link from "next/link";
import { useTranslation } from "react-i18next";

import bgImage from "../../public/images/bg/bg-image-10.jpg";

const slugify = (str) =>
  String(str)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/(^_|_$)/g, "");

const BlogBreadCrumb = ({ matchedBlog }) => {
  const { t } = useTranslation("blog");
  const authorSlug = matchedBlog ? slugify(matchedBlog.name) : "";
  const postId = matchedBlog ? matchedBlog.id : undefined;

  return (
    <>
      <div className="breadcrumb-image-container breadcrumb-style-max-width">
        <div className="breadcrumb-image-wrapper">
          <div className="breadcrumb-dark">
            <LazyImage src={bgImage} alt={t("detail.breadcrumbImageAlt", "Education Images")} />
          </div>
        </div>
        <div className="breadcrumb-content-top text-center">
          <ul className="meta-list justify-content-center mb--10">
            <li className="list-item">
              <div className="author-thumbnail">
                {matchedBlog && (
                  <LazyImage
                    src={matchedBlog.authorImg}
                    width={494}
                    height={494}
                    alt={t("detail.authorImageAlt", "Author Images")}
                  />
                )}
              </div>
              {matchedBlog && (
                <div className="author-info">
                  <Link href="#">
                    <strong>{matchedBlog.name}</strong>
                  </Link>{" "}
                  {t("detail.authorConnector", "in")}{" "}
                  <Link href="#">
                    <strong>{t(`authors.${authorSlug}.position`, matchedBlog.position)}</strong>
                  </Link>
                </div>
              )}
            </li>
            {matchedBlog && (
              <li className="list-item">
                <i className="feather-clock"></i>
                <span>{matchedBlog.date}</span>
              </li>
            )}
          </ul>
          {matchedBlog && (
            <h1 className="title">{t(`posts.${postId}.title`, matchedBlog.title)}</h1>
          )}
          {matchedBlog && <p>{t(`posts.${postId}.desc`, matchedBlog.desc)}</p>}
        </div>
      </div>
    </>
  );
};

export default BlogBreadCrumb;
